/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Filter } from '../../../model/Filter';
import { Command } from '../../../model/Command';
import { ListController } from '../../ListController';

class CompanyListController extends ListController {
    /** @ngInject */
    constructor(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log, companyService,
        filterService, dialogService, $scope) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.companyService = companyService;
        this.filterService = filterService;
        this.dialogService = dialogService;
        this.$scope = $scope;
        // mdDataTable doesn't support ES6 syntax with $ctrl variable in templates. That's why we must attach the reload
        // callback to the scope with an arrow function so as it can be called by this component with the correct 'this'
        // binding.
        this.$scope.reload = () => this.reload();
        this.$log.debug('Controller \'CompanyList\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.paging.sort = 'name';
        this.commands = [];
        this.initFilters();

        this.reload().then(() => this.initCommands());
    }

    /**
     * Initializes the filters available at the top of the view.
     */
    initFilters() {
        this.filters.push(
            Filter.emptyLikeFilter('name', 'model.company.name'),
            Filter.emptyLikeFilter('email', 'model.company.email')
        );
    }

    /**
     * Initializes the commands available in the view header.
     */
    initCommands() {
        this.commands.push(
            Command.stateCommand('ui.company.create', 'images/svg/add.svg', 'gmao.organization.company.create'),
            Command.handlerCommand(undefined, 'images/svg/reset.svg', () => this.reload())
        );
    }

    /**
     * Reloads the list of companies.
     *
     * @return {Promise} A promise providing the list of companies.
     */
    reload() {
        return this.handleRestServiceCall(
            this.companyService.searchEntities({
                params: this.filterService.buildPagingParams(this.paging),
                data: this.filterService.buildFilters(this.filters)
            }),
            data => {
                this.model.data = data.content;
                this.model.totalElements = data.totalElements;
            }
        );
    }

    /**
     * Shows a confirmation dialog before deleting a company. If the dialog is confirmed, the company is deleted.
     *
     * @param {integer} Company ID.
     * @return {Promise} A promise containing the confirmation result.
     */
    showDeleteConfirmationDialog(id) {
        return this.dialogService.showConfirmationDialogWithMessage('ui.company.deleteconfirmation').then(
            confirmed => {
                if (confirmed) {
                    this.deleteCompany(id).finally(() => {
                        this.reload();
                    });
                }
                return confirmed;
            }
        );
    }

    /**
     * Deletes immediately a company without confirmation, and reloads the list of companies.
     *
     * @param {integer} Company ID.
     */
    deleteCompany(id) {
        return this.handleRestServiceCall(this.companyService.deleteEntity(id), () => {
            this.notificationService.pushMessage('ui.company.deleted',
                this.configuration.NOTIFIER_LEVEL_INFO);
        });
    }
}

export const companyListComponent = {
    template: require('./company-list.html'),
    controller: CompanyListController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/component/CompanyList.js